export enum DeviceTabs {
  CEREMONIES = 'events',
  SCREENS = 'screens'
}
